export enum LookupValue {
  AccumulateAt = 'accumulate_at',
  AccumulateBy = 'accumulate_by',
  ActivityType = 'activity_type',
  Administrator = 'administrator',
  AdjudicationStatus = 'adjudication_status',
  ApplicationStatus = 'application_status',
  ApplicationCreatedBy = 'application_created_by',
  AddressType = 'address_type',
  AreaOfCover = 'area_of_cover',
  Association = 'association',
  AssessmentNarrativeType = 'assessment_narrative_type',
  Atc = 'atc',
  Bank = 'bank',
  BankAccountType = 'bank_account_type',
  BusinessType = 'business_type',
  BusinessTypeByBroker = 'business_type_by_broker',
  BusinessTypeByGroup = 'business_type_by_group',
  CaseManager = 'case_manager',
  CaseStatus = 'case_status',
  Category = 'category',
  ClientBankAccount = 'client_bank_account',
  CodingSchemaType = 'coding_schema_type',
  ConsentReason = 'consent_reason',
  Country = 'country',
  CoverStatus = 'cover_status',
  Currency = 'currency',
  Designation = 'designation',
  DesignationProvider = 'designation_provider',
  DosageForm = 'dosage_form',
  EncounterType = 'encounter_type',
  EncounterTypeCode = 'encounter_type_code',
  EntityStatus = 'entity_status',
  FamilyOfBenefit = 'family_of_benefit',
  FacilityType = 'facility_type',
  FormularyClass = 'formulary_class',
  FuneralProduct = 'funeral_product',
  Gender = 'gender',
  Ingredient = 'ingredient',
  InsuredPerson = 'insured_person',
  InteractionDocumentation = 'interaction_documentation',
  InteractionManagement = 'interaction_management',
  InteractionOnset = 'interaction_onset',
  InteractionSeverity = 'interaction_severity',
  IssueStatus = 'issue_status',
  LimitType = 'limit_type',
  LimitMeasure = 'limit_measure',
  MaritalStatus = 'marital_status',
  MasterDrug = 'master_drug',
  MedicalProduct = 'medical_product',
  MessageRouteId = 'message_route_id',
  Module = 'module',
  NationalDrugRegulator = 'national_drug_regulator',
  NationalDrugStatus = 'national_drug_status',
  PayeeType = 'payee_type',
  PrescriptionLimitType = 'prescription_limit_type',
  PriceListType = 'price_list_type',
  Priority = 'priority',
  ProcessingClass = 'processing_class',
  ProcessingSubClass = 'processing_sub_class',
  ProcessingSubClassFuneral = 'processing_sub_class_funeral',
  ProcessingSubClassMedical = 'processing_sub_class_medical',
  Product = 'product',
  Policy = 'Policy',
  ProviderGroup = 'provider_group',
  ProviderNetwork = 'provider_network',
  ProviderRole = 'provider_role',
  RefillMeasure = 'refill_measure',
  ReasonForAdmission = 'reason_for_admission',
  Regulator = 'regulator',
  ReportingClass = 'reporting_class',
  Resolution = 'resolution',
  RoadAccidentFundDocumentation = 'road_accident_fund_documentation',
  RouteOfAdministration = 'route_of_administration',
  StepTherapy = 'step_therapy',
  Title = 'title',
  TransportType = 'transport_type',
  UnitOfMeasure = 'unit_of_measure',
  User = 'user',
  WorkmanCompensationDocumentation = 'workman_compensation_documentation',
  PaymentType = 'payment_type',
  Broker = 'broker',
  BrokerGroup = 'broker_group',
  UnderwritingType = 'underwriting_type',
  UnderwritingCategory = 'underwriting_category',
  GroupCountRange = 'group_count_range',
  Language = 'language',
  Ethnicity = 'ethnicity',
  Payer = 'payer',
  DiagnosisGroup = 'diagnosis_group',
  RemunerationPeriod = 'remuneration_period',
  DocumentType = 'document_type',
  Feature = 'feature',
}
